<template>
  <v-container class="container-card">
    <v-card>
      <TabelaColaboradores />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ConsultaFuncoes",

  components: {
    TabelaColaboradores: () =>
      import("@/components/colaborador/funcao/TabelaFuncoes")
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Funções");
  }
};
</script>
